<script setup>
import { Head } from "@inertiajs/vue3";
import UpdateInfo from "./Sections/UpdateInfo.vue";
import UpdatePassword from "./Sections/UpdatePassword.vue";
import DeleteAccount from "./Sections/DeleteAccount.vue";
import Container from "@/Layouts/Container.vue";
import Header from "@/Components/Header.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";

defineProps({
  user: Object,
  status: String,
});
</script>

<template>
  <Head title="Profil Pengguna" />
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div class="container px-4 mx-auto">
        <!-- Breadcrumbs -->
        <Breadcrumbs
          :breadcrumbs="[
            { name: 'Dashboard', href: route('dashboard') },
            { name: 'Profil', href: route('profile.edit') },
          ]"
        />

        <!-- Page Header -->
        <div class="mb-8">
          <h1 class="text-3xl font-bold text-slate-900">Pengaturan Profil</h1>
          <p class="mt-2 text-slate-600">
            Kelola informasi akun dan pengaturan keamanan Anda
          </p>
        </div>

        <!-- Profile Sections -->
        <div class="space-y-8">
          <UpdateInfo :user="user" :status="status" />
          <UpdatePassword />
          <DeleteAccount v-if="$page.props.can.account_delete" />
        </div>
      </div>
    </template>
  </Container>
</template>
